export default __webpack_public_path__ + "static/media/prev_calendar.6684bf4a.svg";